import { render } from "./ResultadosComponent.vue?vue&type=template&id=ccdad2f2&scoped=true"
import script from "./ResultadosComponent.vue?vue&type=script&lang=js"
export * from "./ResultadosComponent.vue?vue&type=script&lang=js"

import "./ResultadosComponent.vue?vue&type=style&index=0&id=ccdad2f2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccdad2f2"]])

export default __exports__